module.exports = __webpack_public_path__ + "img/2.78bc916d.jpg";